import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SmoothScroll } from "@/lib/motion";
import Home from "@/pages/Home";
import Policy from "@/pages/Policy";

function App() {
  return (
    <LanguageProvider>
      <SmoothScroll>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/policy/:slug" element={<Policy />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#25050F",
                color: "#FDFBF7",
                border: "1px solid rgba(197,158,63,0.4)",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              },
            }}
          />
        </div>
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default App;
